/* tslint:disable:completed-docs */
import { Injectable } from '@angular/core';

import { of, Observable } from 'rxjs';

import { Store } from '../../../utils/storage/abstract-storage';
import { Session } from '../../../utils/storage/session';

@Injectable()
export class StorageService {
  protected storage: Store | any;

  constructor() {}

  setStorage(storage: any) {
    this.storage = storage;
  }

  protected _makeStorage() {
    this.storage = new Session();
  }

  get(key: string): Observable<any> {
    return of(this.storage.getItem(key));
  }

  set(key: string, value: any): Observable<any> {
    return of(this.storage.setItem(key, value));
  }

  remove(key: string): Observable<any> {
    return of(this.storage.deleteItem(key));
  }

  clear(): Observable<void> {
    return of(this.storage.clear());
  }

  length(): Observable<any> {
    return of(this.storage.length());
  }

  keys(): Observable<any> {
    return of(this.storage.keys());
  }
}
